module.exports = __webpack_public_path__ + "assets/img/KeyReport_003.a5145210-ps.jpg";